// axios.js
import axios from "axios";
// import { message } from "ant-design-vue"; // 这里是引用了一个公共的弹框

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl;
    this.queue = {};
    axios.defaults.timeout = 30000;
  }
  getInsideConfig() {
    return {
      baseURL: this.baseUrl
    };
  }
  destroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true;
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url);
        const { data, status } = res;
        return { data, status };
      },
      error => {
        this.destroy(url);
        let errorInfo = error.response;
        if (!errorInfo) {
          const {
            request: { statusText, status },
            config
          } = JSON.parse(JSON.stringify(error));
          errorInfo = {
            statusText,
            status,
            request: { responseURL: config.url }
          };
        }
        this.addErrorLog(errorInfo);
        return Promise.reject(error);
      }
    );
  }
  addErrorLog(err) {
    // console.log(err);
    const { status } = err;
    switch (status) {
      case 510:
        // console.log(err);
        // message.error("登录失效，请重新登录");
        break;
      case 500:
        // message.error(err.data);
        break;
      case 404:
        // err.data.message === "No message available"
        //   ? message.error("请求错误")
        //   : message.error(err.data.message);
        break;
      default:
        // message.error(err.data);
    }
    console.log(err);
  }
  request(options) {
    console.log(options)
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(options), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}
export default HttpRequest;


// WEBPACK FOOTER //
// ./src/http/axios.js